module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.1025a6e0.ttf";